import { Gender, AssociationRoleEnum } from '@/models/Enums';

export default class PersonRegistrationRequest {
    firstName: string;
    lastName: string;
    socialSecurityNumber: string;   
    email: string;
    mobile: string;
    zipCode: string;
    city: string;
    address: string;
    gender: Gender | null;
    associationRole: AssociationRoleEnum | null;
    groupIds: Array<number>;
    isDisabled: boolean;
    hasNoSwedishSsn: boolean;

    constructor(
        firstName: string,
        lastName: string,
        socialSecurityNumber: string,        
        email: string,
        mobile: string,
        zipCode: string,
        city: string,
        address: string,
        gender: Gender | null,
        associationRole: AssociationRoleEnum | null,
        groupIds: Array<number>,
        isDisabled: boolean,
        hasNoSwedishSsn: boolean,
    ) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.socialSecurityNumber = socialSecurityNumber;        
        this.email = email;
        this.mobile = mobile;
        this.zipCode = zipCode;
        this.city = city;
        this.address = address;
        this.gender = gender;
        this.associationRole = associationRole;
        this.groupIds = groupIds;
        this.isDisabled = isDisabled;
        this.hasNoSwedishSsn = hasNoSwedishSsn;
    }
}